export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmación"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sí"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¿Está seguro de que desea continuar?"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar criptoactivo"])}
}